import { Component, OnInit } from '@angular/core';
import { Reference, ReferencesResult } from 'app/core/services/api-client';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { I18nService } from 'app/core/services/i18n/i18n.service';
import { IAppState } from 'app/modules/shared-area/root-state';
import { ReferencesActions, ReferencesSelectors } from './ducks/store';

@Component({
  selector: 'app-references-dialog',
  templateUrl: './references-dialog.component.html',
})
export class ReferencesDialogComponent implements OnInit {
  public isBusy$: Observable<boolean>;
  public result$: Observable<ReferencesResult>;

  constructor(
    private store: Store<IAppState>,
    private i18n: I18nService,
  ) {}

  ngOnInit() {
    this.isBusy$ = this.store.pipe(select(ReferencesSelectors.isBusy));
    this.result$ = this.store.pipe(select(ReferencesSelectors.getReferences));
  }

  loadMore() {
    this.store.dispatch(ReferencesActions.loadMore());
  }

  getType(reference: Reference) {
    const objectType = reference.erfassungId ? 'Erfassung' : reference.objektTyp;
    return this.i18n.getLocalizedString('objektTyp.' + objectType);
  }
}
